import config from "@/config/index";
import api from "../../utils/axios-util";
import * as mutation_type from "../mutation-types";
const state = config.PauseCode;
var getters = {
    GetTicketStatus: state => state.ticketStatus
};
const mutations = {
    [mutation_type.ticketStatus]: (state, response) => {
        state.ticketStatus = response;
    },
    [mutation_type.CommitNothing]: () => { }
};
const actions = {
    GetTicketStatus: ({ commit },payload ) => {
        return new Promise((resolve, reject) => {
            
            try {
                let skip = payload.skip;
                let take = payload.take;
                let filter = ""
                if(payload.status){
                    filter +=`&status=${payload.status}`
                }
                if(payload.name){
                    filter +=`&name=${payload.name}`
                }
                api
                    .get(`/ticketstatus/fetch?skip=${skip}&take=${take}`+filter)
                    .then(response => {
                        const disposition = response.data.data;
                        commit(mutation_type.Disposition, disposition);
                        if(disposition){
                            const ticket_array = [];
                            disposition.forEach(ticket => {
                                ticket_array.push(ticket.name);
                            });
                            localStorage.setItem("group_disposition", JSON.stringify(ticket_array));
                        }
                        resolve(response);
                    })
                .catch(function (error) {
                    reject(error);   
                });
            } catch (error) {
                reject(error);
            }
        });
    },
   
    InsertTicketStatus: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            try {
                api
                    .post(`/ticketstatus/create`, payload)
                    .then(response => {
                        commit(mutation_type.CommitNothing, {});
                        resolve(response);
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            } catch (error) {
                reject(error);
            }
        });
    },
    deleteTicketStatus: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            try {
                api
                    .delete(`/ticketstatus/delete/${payload}`)
                    .then(response => {
                        commit(mutation_type.CommitNothing, {});
                        resolve(response);
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            } catch (error) {
                reject(error);
            }
        });
    },
    updateTicketStatus: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            try {
                const id = payload.id;
                delete payload.id;
                api
                    .put(`/ticketstatus/update/${id}`, payload)
                    .then(response => {
                        commit(mutation_type.CommitNothing, {});
                        resolve(response);
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            } catch (error) {
                reject(error);
            }
        });
    }
};
export default {
    state,
    getters,
    mutations,
    actions
};